<template>
  <ul>
    <li v-for="(item,index) in 10"
        :key="index"
        :class="[index%2?'another':'self']">
      <div class="active-time-wrap">
        <span class="active-time">2019-07-26 15:49:07</span>
      </div>
      <div class="user-info">
        <!-- 别人的消息 -->
        <template v-if="index%2">
          <img class="avatar"
               src="../../../assets/logo.png"
               alt="">
          <span class="username">王婵</span>
          <span class="role gray">管理员</span>
          <el-button class="deal-btn"
                     type="text"
                     v-if="is_user">回复</el-button>
          <el-button class="deal-btn"
                     type="text"
                     v-if="is_user">删除</el-button>
        </template>
        <!-- 自己的消息 -->
        <template v-else>
          <el-button class="deal-btn"
                     type="text">撤回</el-button>
          <span class="role gray">讲师</span>
          <span class="username">葛鹏</span>
          <img class="avatar"
               src="../../../assets/logo.png"
               alt="">
        </template>

      </div>
      <div class="message-wrap">
        <div class="message"
             v-if="index%3">智东西公开课AI芯片社群开放啦！AI芯片技术群、AI芯片行业群两类社群，欢迎申请。扫码申请，备注“姓名-公司-职位”的朋友将优先通过</div>
        <div class="message voice"
             @click="playAudio"
             v-else>
          <template v-if="!(index%2)">
            <el-badge is-dot
                      class="item">
              <span>60s</span>
            </el-badge>
            <icon-svg class="icon-voice"
                      icon-class="voice" />
          </template>
          <template v-else>
            <icon-svg class="icon-voice"
                      icon-class="voice" />
            <el-badge is-dot
                      class="item">
              <span>60s</span>
            </el-badge>
          </template>
          <audio preload="auto"
                 @ended="playEnd"
                 src="http://oss.zhidx.com/live/uploads/audio/2019/07/5d3edb294358b1564400425.mp3"></audio>
        </div>
      </div>
    </li>
  </ul>
</template>

<script>
export default {
  props: {
    is_user: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isPlay: false,
      currentAudioPlay: null,
    }
  },
  methods: {
    playAudio (e) {
      const target = e.target
      const audio = $(target).find('audio')[0]
      //先暂停其他正在播放的音频文件
      if (this.currentAudioPlay) {
        if (this.currentAudioPlay == audio && audio.pausedc) {
          this.currentAudioPlay.play()
        } else if (this.currentAudioPlay == audio && !audio.pausedc) {
          this.currentAudioPlay.pause()
        } else {
          this.currentAudioPlay.pause()
          this.currentAudioPlay = audio
          audio.play()
        }
      } else {
        this.currentAudioPlay = audio
        audio.play()
      }
    },
    playEnd (e) {
      console.log(e)
    }
  }
}
</script>

<style lang="less" scoped>
li {
  & + li {
    margin-top: 15px;
  }
}
.user-info {
  display: flex;
  align-items: center;
}
.avatar {
  width: 24px;
  height: 24px;
  border-radius: 50%;
}
.username {
  display: inline-block;
  max-width: 87px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.role {
  min-width: 28px;
}
.active-time-wrap {
  margin: 20px 0 10px;
  text-align: center;
  .active-time {
    display: inline-block;
    padding: 0 20px;
    color: @gray;
    font-size: 12px;
    background-color: #f5f5f5;
    border-radius: 10px;
    line-height: 20px;
  }
}
.message {
  margin-top: 10px;
  padding: 10px;
  background-color: @table-bg;
  border: 1px solid @border-color;
  font-size: 12px;
  line-height: 15px;
  display: inline-block;
  text-align: left;
  &.voice {
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
    margin: 0 34px;
    audio {
      height: 0;
    }
  }
}
.another {
  .deal-btn,
  .role,
  .username {
    margin-left: 8px;
  }
  .message-wrap {
    text-align: left;
  }
  .message {
    margin-left: 34px;
    border-radius: 0 10px 10px 10px;
  }
}
.self {
  .user-info {
    justify-content: flex-end;
  }
  .deal-btn {
    padding: 0;
  }
  .deal-btn,
  .role,
  .username {
    margin-left: 0;
    margin-right: 8px;
  }
  .message-wrap {
    text-align: right;
  }
  .message {
    margin-right: 34px;
    border-radius: 10px 0 10px 10px;
    position: relative;
    &.voice {
      .icon-voice {
        transform: rotate(180deg);
      }
    }
  }
}
</style>


